import TimeDueComp from '../../InvoiceScan/CellComp/TimeDueComp'
import '@/components/_modules/Invoices/statuses.scss'

export default {
  get: function () {
    let model = {
      'PaymentInvoiceId': '_',
      'InvoiceNumber': {
        label: 'Invoice',
        width: 150
      },
      Client: {
        label: 'Client',
        width: 150
      },
      Planner: {
        label: 'Submitted By',
        width: 160
      },
      Created: {
        label: 'Date Submitted',
        type: 'text',
        width: 150
      },
      Until: {
        label: 'Due',
        width: 150,
        type: 'tags',
        render: TimeDueComp
      },
      'InitialTotalAmount': {
        label: 'Amount',
        width: 140
      },
      Scanner: {
        label: 'Assigned To',
        width: 150
      },
      Reviewer: {
        label: 'Reviewer',
        type: 'text',
        width: 110
      },
      ProgramName: {
        label: 'Scanning Status',
        width: 150,
        getter: getScanningStatus
      },
      DivisionName: {
        label: 'Division',
        width: 150
      },
      BusinessUnit: {
        label: 'Business Unit',
        width: 150
      }
    }

    return model
  }
}

function getScanningStatus(params) {
  const data = params.data || {}
  const isPending = data && (data.Scanner || '').trim() !== '' && data.InvoiceWasSaved
  if (data.IsFromEmailForScanning) {
    return '<span class="badge incomplete">Incomplete</span>'
  }
  return isPending ? 'Pending' : 'Open'
}




// WEBPACK FOOTER //
// ./src/components/_modules/InvoiceScan/models/scan-invoice-model.js